import { currencySymbolMap } from '@/lib/currency-symbol-map/map.utils';

export const getSymbolFromCurrency = (currencyCode: string) => {
    const code = currencyCode.toUpperCase();
    if (!Object.prototype.hasOwnProperty.call(currencySymbolMap, code)) {
        return;
    }

    return currencySymbolMap[code];
};
